import Table from '@views/adminRole/table/Table'

const AdminRole = () => {
	return (
		<div>
			<h2>계열기업 관리</h2>
			<Table />
		</div>
	)
}

export default AdminRole